export default "__VITE_ASSET__RM_adFF1__"